import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Box } from '@material-ui/core';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
    openPopup,
    selectTotalPerksQuantity,
} from '../../features/cart/cartSlice';

const useStyles = makeStyles(
    ({ breakpoints, spacing, palette, typography }) => ({
        stickyWrapper: {
            position: 'sticky',
            height: 0,
            top: spacing(3),
            width: '100%',
            display: 'flex',
            justifyContent: 'end',
            zIndex: 1000,
            '@media (max-width: 600px)': {
                top: spacing(0.5),
            },
        },
        increasedSpacing: {
            top: spacing(12),
        },
        root: {
            position: 'sticky',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            right: spacing(3),
            padding: spacing(1),
            marginTop: spacing(3),
            width: '30px',
            height: '30px',
            background: palette.background.primaryLight,
            border: `1px solid ${palette.background.accent}`,
            borderRadius: '5px',
            cursor: 'pointer',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                right: 0,
                width: '45px',
                height: '45px',
                '& svg': {
                    fontSize: '2rem',
                },
            },
        },
        '@keyframes bounceAnimation': {
            '0%': {
                transform: 'scale(1)',
            },
            '50%': {
                transform: 'scale(1.5)',
            },
            '100%': {
                transform: 'scale(1)',
            },
        },
        quantity: {
            alignItems: 'center',
            background: palette.primary.main,
            borderRadius: '50%',
            color: palette.primary.contrastText,
            display: 'flex',
            fontSize: '1rem',
            fontWeight: 600,
            height: '1rem',
            justifyContent: 'center',
            padding: spacing(0.5),
            position: 'absolute',
            right: '-0.8rem',
            top: '-0.7rem',
            width: '1.1rem',
            zIndex: 1,
            fontFamily: typography.fontFamily,
            'html[dir=rtl] &': {
                right: 'auto',
                left: 0,
            },
            '&.animate': {
                animation: `$bounceAnimation 500ms ease-in-out`,
            },
        },
    }),
);

function ShoppingCartButton(props) {
    const { openPopup, quantity, increaseTopSpacing } = props;
    const classes = useStyles();

    const [showAnimation, setShowAnimation] = useState(false);

    useEffect(() => {
        setShowAnimation(false);
        requestAnimationFrame(() => {
            setShowAnimation(true);
        });
    }, [quantity]);

    return (
        <div
            className={classNames(classes.stickyWrapper, {
                [classes.increasedSpacing]: increaseTopSpacing,
            })}
        >
            <Box className={classes.root} onClick={openPopup}>
                {quantity > 0 && (
                    <div
                        className={classNames(classes.quantity, {
                            animate: showAnimation,
                        })}
                    >
                        {quantity}
                    </div>
                )}
                <ShoppingCartIcon />
            </Box>
        </div>
    );
}

ShoppingCartButton.propTypes = {
    openPopup: PropTypes.func,
    quantity: PropTypes.number,
    increaseTopSpacing: PropTypes.bool,
};

const mapStateToProps = state => ({
    quantity: selectTotalPerksQuantity(state),
});

const mapDispatchToProps = dispatch => ({
    openPopup() {
        dispatch(openPopup());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCartButton);
